import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import LayoutDefault from './layouts/LayoutDefault';
import LayoutDashboard from './layouts/LayoutDashboard';

const routes = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/dashboard" />
    },
    // {
    //     path: '/auth',
    //     component: LayoutDefault,
    //     routes: [
    //         {
    //             path: '/auth/login',
    //             exact: true,
    //             component: lazy(() => import('./pages/login/login'))
    //         },
    //         {
    //           component: () => <Redirect to="/errors/not-found" />
    //         }
    //     ]
    // },
    {
      path: '/errors',
      component: LayoutDefault,
      routes: [
        {
          path: '/errors/not-found',
          exact: true,
          component: lazy(() => import('./pages/not-found'))
        },
        {
            path: '/errors/error',
            exact: true,
            component: lazy(() => import('./pages/error'))
          },
        {
          component: () => <Redirect to="/errors/not-found" />
        }
      ]
    },
    {
        path: '*',
        component: LayoutDashboard,
        routes: [
            {
                path: '/dashboard',
                exact: true,
                component: lazy(() => import('./pages/dashboard'))
            },
            {
                path: '/movimentacoes',
                exact: true,
                component: lazy(() => import('./pages/fluxo-caixa/fluxo-caixa'))
            },
            {
                path: '/contas-bancarias',
                exact: true,
                component: lazy(() => import('./pages/contas-bancarias/contas-bancarias'))
            },
            {
                path: '/centros-custos',
                exact: true,
                component: lazy(() => import('./pages/centros-custos/centros-custos'))
            },
            {
                path: '/clientes',
                exact: true,
                component: lazy(() => import('./pages/clients/clients'))
            },
            {
                path: '/perguntas_respostas',
                exact: true,
                component: lazy(() => import('./pages/perguntas_respostas/perguntas_respostas'))
            },
            {
                path: '/minha-conta',
                exact: true,
                component: lazy(() => import('./pages/meus-dados/meus-dados'))
            },
            {
                path: '/nota-fiscal',
                exact: true,
                component: lazy(() => import('./pages/invoices/invoices'))
            },
            {
                path: '/empresas',
                exact: true,
                component: lazy(() => import('./pages/empresas/empresas'))
            },
            {
                path: '/demonstrativo',
                exact: true,
                component: lazy(() => import('./pages/demonstrativo'))
            },
            {
                path: '/calendario',
                exact: true,
                component: lazy(() => import('./pages/calendario/calendario'))
            },
            {
                path: '/acessos-usuarios',
                exact: true,
                component: lazy(() => import('./pages/configuracoes/configuracoes'))
            },
            {
                path: '/relatorios',
                exact: true,
                component: lazy(() => import('./pages/relatorios/relatorios'))
            },
            {
                path: '/relatorios/:id',
                exact: true,
                component: lazy(() => import('./pages/relatorios/report-detail'))
            },
            {
                path: '/help',
                exact: true,
                component: lazy(() => import('./pages/help/help'))
            },
            {
                path: '/pdv',
                exact: true,
                component: lazy(() => import('./pages/pdv/pdv'))
            },
            {
                path: '/pdv/:id',
                exact: true,
                component: lazy(() => import('./pages/pdv/pdv'))
            },
            {
                path: '/pdv-movimentacoes',
                exact: true,
                component: lazy(() => import('./pages/pdv/pdv-list'))
            },
            {
                path: '/pdv-configuracoes',
                exact: true,
                component: lazy(() => import('./pages/pdv/pdv-configuracoes'))
            },
            {
                path: '/meus-produtos',
                exact: true,
                component: lazy(() => import('./pages/meus-produtos/meus-produtos'))
            },
            {
                path: '/ordens-compra',
                exact: true,
                component: lazy(() => import('./pages/ordens-compra/ordens-compra'))
            },
            {
                path: '/declaracoes-guias',
                exact: true,
                component: lazy(() => import('./pages/declaracoes_guias/declaracoes_guias'))
            },
            {
                path: '/funcionarios',
                exact: true,
                component: lazy(() => import('./pages/funcionarios/funcionarios'))
            },
            {
                path: '/meu-ponto',
                exact: true,
                component: lazy(() => import('./pages/meu-ponto/meu-ponto'))
            },
            {
                path: '/fornecedores',
                exact: true,
                component: lazy(() => import('./pages/fornecedores/fornecedores'))
            },

            
            {
                component: () => <Redirect to="/errors/not-found" />
            }
        ]
    }
];

export default routes;